/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreAddRejectionDto } from '../../models/core-add-rejection-dto';
import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerAddRejection$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the subtask to add rejection to.
 */
  id: string;
      body: CoreAddRejectionDto
}

export function projectSubtasksControllerAddRejection(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerAddRejection$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerAddRejection.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>;
    })
  );
}

projectSubtasksControllerAddRejection.PATH = '/o2-core/project-subtasks/{tenant}/{id}/rejection';
